import axios from 'axios';

const timeout = 10000;
const baseURL = process.env.REACT_APP_BASE_API;
// const baseURL = 'http://176.31.106.73:31989/api';
// const baseURL = 'http://151.80.27.45:2351/api';
// const baseURL = 'https://preprod.maxken.fr/voissa-api/api';
// const baseURL = 'http://localhost:3030/api';
// const baseURL = 'http://192.168.1.101:3030/api';
// const baseURL = `https://api.voissa.fr`;
// axios.defaults.withCredentials = true;
const apiUrl = axios.create({
    baseURL,
    timeout,
    withCredentials: true
});

function getCurrentSPAVersion(){
    const currentScript = document.currentScript;
    let version = false;
    if (currentScript){
        let scriptPath = currentScript.getAttribute('src');
        const match = /main\.([a-z0-9]{8})\.chunk\.js/.exec(scriptPath);
        if (match) {
            version = match[1];
            console.log('SPA version ', version);
            if (localStorage.getItem('spa-last-refresh-version') === version) localStorage.removeItem('spa-last-refresh-version');
        }
        return version;
    }
    else return version;
}

function checkSPAVersionAndRefresh(currentVersion, lastVersion) {
    if (!!currentVersion && !!lastVersion && (currentVersion !== lastVersion)){
        if (localStorage.getItem('spa-last-refresh-version') !== lastVersion){
            localStorage.setItem('spa-last-refresh-version', lastVersion);
            console.log(`SPA updated, local version [${currentVersion}], updated version [${lastVersion}]\nRefreshing...`);
            window.location.reload(true);
        }
    }
}

let currentSPAVersion = getCurrentSPAVersion();

apiUrl.interceptors.response.use(function (res){
    checkSPAVersionAndRefresh(currentSPAVersion,res.headers['spa-last-version']);
    return res;
})

apiUrl.interceptors.request.use(function (config){
    const token = localStorage.getItem(process.env.REACT_APP_TOKEN_NAME);
    if (token != null) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
})

const getForumsStatsFromApi = () => apiUrl.get(`/forums/stats`);
const tools = {
    getLiveBottom: (data = {}) => apiUrl.get(`/tools/live-bottom`, { params:data})
}

const fetchFluxChaturbate = () => apiUrl.get(`/tools/chaturbate`);
const fetchFluxXlovecam = () => apiUrl.get(`/tools/xlovecam`);

const fetchUrlChatWebcam = () => apiUrl.get(`/users/me/chat-webcam`);

export {
    apiUrl,
    getForumsStatsFromApi,
    tools,
    fetchUrlChatWebcam,
    fetchFluxChaturbate,
    fetchFluxXlovecam
};
